import { render, staticRenderFns } from "./SuperDocInputArea.vue?vue&type=template&id=320ffbaf&scoped=true"
import script from "./SuperDocInputArea.vue?vue&type=script&lang=js"
export * from "./SuperDocInputArea.vue?vue&type=script&lang=js"
import style0 from "./SuperDocInputArea.vue?vue&type=style&index=0&id=320ffbaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320ffbaf",
  null
  
)

export default component.exports